import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Snackbar,
  Alert,
  MenuItem,
  ListItemText,
} from '@mui/material';
import StandardDialog, { StandardDialogActions } from '../../features/Modals/StandardDialog';
import { useAppSelector } from '../../app/hooks';

type ReportRequestButtonProps = {
  type: string;
  onRequest?: () => void | Promise<void>;
  onAfterRequest?: () => void;
};

const ReportRequestButton: React.FC<ReportRequestButtonProps> = ({
  type,
  onRequest,
  onAfterRequest,
}) => {
  const { user } = useAppSelector((state) => state.user);

  const [open, setOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleOpen = async () => {
    try {
      if (onRequest) await onRequest();
      if (onAfterRequest) onAfterRequest();
      setOpen(true);
    } catch (e) {
      console.error(`Failed to request ${type} report`, e);
      setErrorMessage(`Failed to request ${type} report. Please try again.`);
      setErrorOpen(true);
    }
  };

  const handleClose = () => setOpen(false);
  const handleErrorClose = () => setErrorOpen(false);

  return (
    <>
      <MenuItem onClick={handleOpen}>
        <ListItemText>Email Full Export</ListItemText>
      </MenuItem>
      <Snackbar
        open={errorOpen}
        autoHideDuration={3000}
        onClose={handleErrorClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleErrorClose} severity="error" variant="filled">
          {errorMessage}
        </Alert>
      </Snackbar>

      <StandardDialog
        isOpen={open}
        handleClose={handleClose}
        title={`All ${type}\u2019s Report Request`}
      >
        <Typography>
          Thank you, {user?.firstName}. Your request for the {type}
          {'\u2019'}s report has been received. Once the report is ready, it will be sent to {user?.email}.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
          <StandardDialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
          </StandardDialogActions>
        </Box>
      </StandardDialog>
    </>
  );
};

export default ReportRequestButton;
